import { useEffect, useState } from 'react';

/**
 * O valor depois de `delayMs` sem mudar. O valor inicial vale na hora (a tela aberta com o termo na
 * URL busca sem esperar); só as mudanças seguintes esperam a pausa.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (Object.is(value, debounced)) return;
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, debounced, delayMs]);

  return debounced;
}
